import { getColor } from "../../tools";

export default function Dot({ label }) {
    return (
      <div
        style={{
          height: 12,
          width: 12,
          backgroundColor: getColor(label),
          marginRight: "5px",
          marginTop: "4px",
          borderRadius: "50%",
        }}
      />
    );
  }